import { Formik, Form } from 'formik';
import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import * as Yup from "yup";
import db from "../../../api/mongodb";
import logo from "../../../images/safe-logo-login.svg";
import Button from "react-bootstrap/Button";
import TextInput from "./TextInput";
import { useQuery } from './Login';


const schema = Yup.object({
    oneTimePassCode: Yup.string().required("Required"),
});

const TwoFactorPage = () => {
    const navigate = useNavigate()
    const [errorMsg, setErrorMsg] = useState("");

    const { state } = useLocation()

    let query = useQuery();


    const generateOTP = () => {
        try {
            db.post("/api/safeAPs/generateOTP", {

                email: state.user.email,
                password: state.user.password

            })
                .then((response) => {
                    // console.log(response)
                    // localStorage.setItem("token", response.data.token);
                    if (response.status === 200) {

                    } else {
                        navigate("/")
                    }
                })
                .catch((error) => {
                    navigate("/")
                });
        } catch (err) { }


    }

    return (
        <Formik
            initialValues={{ oneTimePassCode: "" }}
            validationSchema={schema}
            onSubmit={(values, { setSubmitting }) => {
                const user = {
                    oneTimePassCode: values.oneTimePassCode,
                };

                setErrorMsg("");

                try {
                    db.post("/api/safeAPs/login",
                        {
                            email: state.user.email,
                            password: state.user.password,
                            oneTimePassCode: user.oneTimePassCode
                        })
                        .then((response) => {
                            // console.log(response)
                            // localStorage.setItem("token", response.data.token);
                            if (response.status === 200) {
                                db.get(`api/safeAPs/${response.data._id}`, {
                                    headers: {
                                        Authorization: `${localStorage.getItem("token")}`,
                                    },
                                }).then((login) => {
                                    if (
                                        login.status === 200 &&
                                        login.data.status === "approved"
                                    ) {
                                        // console.log(login.data)
                                        sessionStorage.setItem("id", login.data._id)

                                        const redirectLink = query.get("redirectLink")
                                        console.log(redirectLink)
                                        if (redirectLink) {
                                            window.location.replace(redirectLink)
                                            // window.location.href = redirectLink;
                                            // navigate(`${redirectLink}`);

                                        } else {
                                            navigate("/projects/active");


                                        }
                                    } else {
                                        setErrorMsg("Invalid token");
                                    }
                                });
                            } else {
                                setErrorMsg("Invalid token");
                            }
                        })
                        .catch((error) => {
                            setErrorMsg("Invalid token");
                        });
                } catch (err) { }

                setSubmitting(false);
            }}
        >
            <div className="login-background">
                <div className="login-card" style={{ paddingBottom: "100px" }}>
                    <Link to="/" className="safe-login-logo">
                        <img src={logo} alt="logo" width={200} style={{ paddingTop: "25px" }} />
                    </Link>



                    <Form className="login-form" autoComplete="on" noValidate>
                        <p style={{ color: "#011936", fontWeight: "bold" }}>
                            A one time passcode has been sent to your email
                        </p>

                        <TextInput
                            label="One time passcode"
                            name="oneTimePassCode"
                            type="number"
                            placeholder="Enter token"
                            required
                            errorMsg={errorMsg}
                        />

                        <p className="forgotPsw" style={{ cursor: "pointer" }} onClick={generateOTP}>Resend code</p>

                        <Button
                            className="login btn-primary"
                            variant="primary"
                            type="submit"
                        >
                            Log in
                        </Button>

                        <p className="terms" style={{ marginTop: "25px" }}>
                            By logging in, you are agreeing to our &nbsp;
                            <span>
                                <a target="_blank" href={`${process.env.REACT_APP_API_URL}/termsAndConditions`}>
                                    <strong>terms & conditions</strong>
                                </a>
                            </span>
                        </p>
                    </Form>
                </div>
                <p className="copyright-text">
                    © Copyright {new Date().getFullYear()} SAFE Design Technologies Inc.
                </p>
            </div>

        </Formik>




    );
};

export default TwoFactorPage;